const request = async (url, options = {}) => {
  let response
  try {
    response = await fetch(`/api${url}`, { headers: { 'Content-Type': 'application/json', token: localStorage.getItem('token') || '' }, ...options })
  } catch {
    throw new Error('网络连接异常，请稍后重试')
  }

  const body = await response.text()
  let result
  try {
    result = body ? JSON.parse(body) : null
  } catch {
    result = null
  }

  if (!response.ok || !result) throw new Error('服务暂时不可用，请稍后重试')
  if (result.code !== 200) throw new Error(result.msg || '请求未完成，请稍后重试')
  return result.data
}
export const api = {
  bootstrap: () => request('/website/bootstrap'),
  createScan: () => request('/website/scan/create', { method: 'POST', body: '{}' }),
  scanStatus: id => request(`/website/scan/status?id=${id}`),
  submitRequest: data => request('/website/project/request', { method: 'POST', body: JSON.stringify(data) }),
  createOrder: planCode => request('/website/member/order', { method: 'POST', body: JSON.stringify({ planCode }) }),
  profile: () => request('/website/member/me'),
  updateProfile: data => request('/website/member/profile', { method: 'POST', body: JSON.stringify(data) }),
  uploadAvatar: async file => {
    const form = new FormData()
    form.append('file', file, file.name)
    const response = await fetch('/api/upload/file', { method: 'POST', headers: { token: localStorage.getItem('token') || '' }, body: form })
    const result = await response.json().catch(() => null)
    if (!response.ok || !result?.url) throw new Error('头像上传失败，请稍后重试')
    return result.url
  }
}
